export default __webpack_public_path__ + "static/278132126_384113933578325_2212920422578428876_n-02fbb1853339b38327b627168e8530f7.jpeg";